import React, { forwardRef, useImperativeHandle, useEffect } from 'react';
import { useDispatch } from 'react-redux';
//slices
import { setRectARI } from '../../../../../../../store/slices/reportsSlice';


const Step2MarkFrame = forwardRef(({ rectDrawCoords, isDrawing, imgRef, imgContainerRef, rectRef, isMobile }, ref) => {
    const dispatch = useDispatch();
    
    useImperativeHandle(ref, () => ({ handleSubmit, }));

    const handleSubmit = async () => {
    };

    const rectDrawMD = (e) => {
        if (imgContainerRef.current && rectRef.current) {
            isDrawing.current = true;
            const imgRect = imgContainerRef.current.getBoundingClientRect();
            const x = e.clientX - imgRect.left;
            const y = e.clientY - imgRect.top;
            rectDrawCoords.current = { startX: x, startY: y };
            rectRef.current.style.left = `${x}px`;
            rectRef.current.style.top = `${y}px`;
            rectRef.current.style.width = '0px';
            rectRef.current.style.height = '0px';
            rectRef.current.style.display = 'block';
        }
    };

    const rectDrawMM = (e) => {
        if (!isDrawing.current) return;
        const imgRect = imgContainerRef.current.getBoundingClientRect();
        const currentX = e.clientX - imgRect.left;
        const currentY = e.clientY - imgRect.top;

        const {startX, startY} = rectDrawCoords.current;
        
        const x = Math.min(currentX, startX);
        const y = Math.min(currentY, startY);
        const width = Math.abs(currentX - startX);
        const height = Math.abs(currentY - startY);
        rectDrawCoords.current = { startX: x, startY: y, width, height };

        rectRef.current.style.left = `${x}px`;
        rectRef.current.style.top = `${y}px`;
        rectRef.current.style.width = `${width}px`;
        rectRef.current.style.height = `${height}px`;
    };

    const rectDrawMU = (e) => {
        if (!isDrawing.current) return;
        isDrawing.current = false;
        const scaleX = imgRef.current.naturalWidth / imgRef.current.clientWidth;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.clientHeight;

        const { startX, startY, width, height } = rectDrawCoords.current;

        const scaled = {
            x: Math.round(startX * scaleX),
            y: Math.round(startY * scaleY),
            width: Math.round(width * scaleX),
            height: Math.round(height * scaleY),
        };
        console.log("Scaled Rect: ", scaled);
        dispatch(setRectARI({ rect: scaled }))
    };


    useEffect(() => {
        const imgContainer = imgContainerRef.current;
        
        if (imgContainer) {
            imgContainer.addEventListener('mousedown', rectDrawMD);
            imgContainer.addEventListener('mousemove', rectDrawMM);
            imgContainer.addEventListener('mouseup', rectDrawMU);
        }
        return () => {
            if (imgContainer) {
                imgContainer.removeEventListener('mousedown', rectDrawMD);
                imgContainer.removeEventListener('mousemove', rectDrawMM);
                imgContainer.removeEventListener('mouseup', rectDrawMU);
            }
        };
    }, []);



    return (
        <div className="p-6 bg-white">
            <h2 className="text-lg font-bold mb-2">Highlight the relevant part of the frame</h2>

            <p>
                Now that you've selected a frame, it's time to focus on the exact area you'd like to highlight.
                You can draw a box directly on the image to mark the area of interest, or if you'd prefer, skip this step and we’ll use the entire frame as the reference.
                To draw a box on the image, click and drag your mouse to create a rectangle around the area you want to highlight.
                If you know the exact coordinates, you can also enter them manually.
            </p>
            
        </div>
    );
});

export default Step2MarkFrame;
